// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3ZM5M","Div":"CustomFadeBox_Div__1IRdG","LargeDiv":"CustomFadeBox_LargeDiv__FoGBu"};